"use strict";

/* eslint no-console: 0, no-throw-literal: 0 */
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _planout = _interopRequireDefault(require("planout"));

var _ExposureLogger = _interopRequireDefault(require("./ExposureLogger"));

var _LabSetup = require("./setup/LabSetup");

var Experiment =
/*#__PURE__*/
function (_planout$Experiment) {
  (0, _inherits2.default)(Experiment, _planout$Experiment);

  function Experiment() {
    (0, _classCallCheck2.default)(this, Experiment);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(Experiment).apply(this, arguments));
  }

  (0, _createClass2.default)(Experiment, [{
    key: "setup",
    value: function setup() {
      throw 'IMPLEMENT setup';
    }
  }, {
    key: "assign",
    value: function assign() {
      throw 'IMPLEMENT assign';
    }
  }, {
    key: "getParamNames",
    value: function getParamNames() {
      return this.getDefaultParamNames();
    }
  }, {
    key: "getUserId",
    value: function getUserId() {
      if (this.inputs && this.inputs.user_id) {
        return this.inputs.user_id;
      }

      var labsUserId = (0, _LabSetup.getUserId)();

      if (labsUserId) {
        return labsUserId;
      }

      if (window.Raven) {
        var errorMessage = '[hublabs-core] Please specify a user id';
        console.error(errorMessage);
        window.Raven.captureException(new Error(errorMessage));
      }

      return null;
    }
  }, {
    key: "logExposure",
    value: function logExposure(extras) {
      this.exposureLogger.logExposure(extras);
    }
  }, {
    key: "configureLogger",
    value: function configureLogger() {
      this.exposureLogger = new _ExposureLogger.default(this);
    }
  }, {
    key: "previouslyLogged",
    value: function previouslyLogged() {
      return this.exposureLogger.previouslyLogged();
    }
  }, {
    key: "flipCoin",
    value: function flipCoin() {
      var p = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0.5;
      return new _planout.default.Ops.Random.BernoulliTrial({
        p: p,
        'unit': this.getUserId()
      });
    }
  }, {
    key: "choose",
    value: function choose() {
      var choices = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var weights = arguments.length > 1 ? arguments[1] : undefined;
      var options = {
        choices: choices,
        'unit': this.getUserId()
      };

      if (weights) {
        options.weights = weights;
      }

      return new _planout.default.Ops.Random.UniformChoice(options);
    }
  }]);
  return Experiment;
}(_planout.default.Experiment);

var _default = Experiment;
exports.default = _default;
module.exports = exports.default;